import styled from 'styled-components/macro';
import { SwitchLabel } from './SwitchLabel';

export const StyledSwitch = styled.input`
  border-radius: 15px;
  cursor: pointer;
  height: 18px;
  opacity: 0;
  width: 35px;
  z-index: 1;

  &:checked + ${SwitchLabel} {
    background-color: #c1c9ca;
    border: 1px solid #c1c9ca;
    &::after {
      border: none;
      background-color: var(--chakra-colors-text-brand);
      border-radius: 50%;
      content: '';
      display: block;
      height: 16px;
      margin-left: 18px;
      margin-top: -4px;
      transition: 0.2s;
      width: 16px;
    }
  }

  &:disabled + ${SwitchLabel} {
    opacity: 0.5;
  }
`;
